module.exports = "/images/ny-blck-2.jpg";